import { gql } from '@apollo/client'

export const START_TARGETED_DB_FLASH_MUTATION = gql`
  mutation startTargetedDbFlash($dishTypeIds: [ID!]!) {
    startTargetedDbFlash(dishTypeIds: $dishTypeIds) {
      includedDishCountInDbFlash
      includedMenuCurationTaskCountInDbFlash
    }
  }
`

export default START_TARGETED_DB_FLASH_MUTATION
